// This is just a dummy component to restrict the props
// that can be passed from outside of the Tabs component


import { FunctionComponent, ReactNode } from "react"

export interface ITabsItemProps {
    id?: string
    label?: string
    badge?: ReactNode
    subItemsAlign?: "left" | "right"
    subItemsWidth?: string
    testId?: string
    error?: boolean

    // internal prop, do not use!
    __TYPE?: "TabsItem"
}

const TabsItem: FunctionComponent<React.PropsWithChildren<ITabsItemProps>> = () => {
    return null
}

export default TabsItem
